export default __webpack_public_path__ + "static/media/banner-3.57320ad6.png";